import { render, staticRenderFns } from "./CallbackView.vue?vue&type=template&id=5fbbcda2&"
import script from "./CallbackView.vue?vue&type=script&lang=js&"
export * from "./CallbackView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports